import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { FontAwesomeIconStatus } from './FontAwesomeIconStatus';

const useStyles = makeStyles()((theme) => ({
  container: { position: 'relative' },
  secondaryIcon: { position: 'absolute', top: -14, right: -14 },
}));

// COMPONENT
function FontAwesomeDoubleIconStatus({
  status,
  status2,
  icon1,
  size1,
  icon2,
  size2,
  style1,
  style2,
  className1,
  ...rest
}) {
  const { classes } = useStyles();
  return (
    <div className={classes.container}>
      <FontAwesomeIconStatus
        icon={icon1}
        size={size1}
        status={status}
        style={style1}
        className={className1}
      />
      <FontAwesomeIconStatus
        className={classes.secondaryIcon}
        icon={icon2}
        size={size2}
        status={status2 ?? status}
        style={style2}
      />
    </div>
  );
}

FontAwesomeDoubleIconStatus.defaultProps = {
  dirty: false,
  submitting: false,
  size1: 'sm',
  size2: 'xs',
};

export default FontAwesomeDoubleIconStatus;
